import { useEffect, useState } from 'react';
import { hasRhReferrer, isRhReferralPricingPath } from './rhPromoPricing';

const POLL_MS = 200;
const MAX_POLL_MS = 15000;

/**
 * Re-renders when Rewardful sets RH_MF70bd716e94.referrer after initial paint.
 */
export function useRhReferralPricing(): boolean {
  const [active, setActive] = useState(
    () => hasRhReferrer() && isRhReferralPricingPath()
  );

  useEffect(() => {
    if (!isRhReferralPricingPath()) return;

    const sync = () => {
      const next = hasRhReferrer() && isRhReferralPricingPath();
      setActive((prev) => (prev === next ? prev : next));
    };

    sync();

    const started = Date.now();
    const intervalId = window.setInterval(() => {
      sync();
      if (hasRhReferrer() || Date.now() - started >= MAX_POLL_MS) {
        window.clearInterval(intervalId);
      }
    }, POLL_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  return active;
}
